export const ADD_POKEMON = "ADD_POKEMON";
export const REMOVE_POKEMON = "REMOVE_POKEMON";
export const EDIT_POKEMON = "EDIT_POKEMON";
export const ADD_MOVE = "ADD_MOVE";
export const REMOVE_MOVE = "REMOVE_MOVE";
export const ADD_ERROR = "ADD_ERROR";
export const REMOVE_ERROR = "REMOVE_ERROR";


// WEBPACK FOOTER //
// ./src/store/actionTypes.js